import styled from 'styled-components'

export const Input = styled.input`
  opacity: 0;
`

export const TrashButton = styled.button`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 13px;
  background-color: ${props => props.theme.color.deprecated.stoneLighter};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${props => props.theme.color.deprecated.stoneDark};
  }
  svg {
    position: absolute;
    right: 6px;
  }
`

export const Container = styled.div`
  position: relative;
  margin: ${props => props.theme.spacing(6)} 0 0 0;
  border-radius: ${props => props.theme.spacing(2)};
  border: 1px dashed ${props => props.theme.color.deprecated.stoneDark};
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 100%;
  padding: 57px 68px 57px 67px;
`
